/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportFundOperationDtoFundingRequest
 */
export interface MovementOnFundsReportFundOperationDtoFundingRequest {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoFundingRequest
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoFundingRequest
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoFundingRequest
   */
  createdAt: Date;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoFundingRequest
   */
  name: string;
}

export function MovementOnFundsReportFundOperationDtoFundingRequestFromJSON(
  json: any
): MovementOnFundsReportFundOperationDtoFundingRequest {
  return MovementOnFundsReportFundOperationDtoFundingRequestFromJSONTyped(json, false);
}

export function MovementOnFundsReportFundOperationDtoFundingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportFundOperationDtoFundingRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    name: json["name"],
  };
}

export function MovementOnFundsReportFundOperationDtoFundingRequestToJSON(
  value?: MovementOnFundsReportFundOperationDtoFundingRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    name: value.name,
  };
}
